import React from 'react';
import * as C from "../componentsM/index"

const Action = () => {
    return (
        <>


            <C.Hero title={"ACTION"}
                image={"/hero/history.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>Action (learning by doing and experiencing) is a key component in constructivist models of education, including the kind of teaching and learning common to all IB programmes. Service has always been a shared value of the IB community. IB learners strive to be caring members of the community who demonstrate a personal commitment to service, and act to make a positive difference to the lives of others and to the environment. The International School values service with others as an important way to engage in principled action across a range of overlapping local and global communities. Through responsible action, tightly connected with sustained enquiry and critical reflection, young people and adults can develop the kinds of attributes described by the learner profile that are essential for success in future academic pursuits and for adult life .</p>

                    <p>In the PYP, action has a specific meaning as an element of the programme in which there is an expectation that successful enquiry will lead to responsible action, initiated by the student as a result of the learning process. This kind of student action may have a wider social impact, and it always represents a voluntary demonstration of a student’s empowerment.</p>


                    <p>Action in the MYP builds upon the action initiated in the PYP and continues as an essential component of the learning process, both as part of the programme’s educational philosophy and as a practical outcome of students’ learning. In the IB continuum, this evolves into the DP Core Programme which consists of the three distinct components of Creativity, Activity, Service (CAS) requirements, in which students continue to increase their awareness of their own strengths and areas for growth, undertake new challenges, plan and initiate activities, work collaboratively with others, show perseverance and commitment, engage with locally and globally significant challenges and consider the ethical implications of their actions.</p>

                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>IB learners strive to:</h1>

                    <p>Action and Service in IB Programmes</p>

                    <ul className="list-disc list-inside my-2">
                        {[
                            "Be caring members of the community who demonstrate a personal commitment to service",
                            "Act to make a positive difference to the lives of others and to the environment",
                            "Develop their personal understanding, their emerging sense of self and their developmentally appropriate responsibility in their community"
                        ].map((item, index) => (
                            <li key={index} className="text-sm">{item}</li>
                        ))}
                    </ul>





                    <h1 className='font-bold text-xl md:text-3xl text-myBlue'>Action may involve students in</h1>


                    <ul className="list-disc list-inside my-2">
                        {[
                            " feeling empathy towards others",
                            "making small-scale changes to their behaviour",
                            "undertaking larger and more significant projects",
                            "acting on their own",
                            "acting collaboratively",
                            "taking physical action",
                            "suggesting modifications to an existing system to the benefit of all involved",
                            "lobbying people in more influential positions to act"
                        ].map((item, index) => (
                            <li key={index} className="text-sm">{item}</li>
                        ))}
                    </ul>


                    <p>The service as action continuum could be summarised by the following diagram:</p>

                    <figure className='md:w-[45%]'>
                        <img src="/action.jpg" alt='Service as action continuum diagram' className='w-full h-full object-contain' />
                    </figure>


                    <p>Service requires that students are able to build authentic connections between what they learn in the classroom and what they encounter in the community. When connected to classroom learning, the experience of service offers opportunities to apply concepts, both skills and knowledge, as students explore the community in its complexity, gain personal insight, develop existing and new skills, and grow in confidence and responsibility as they become “actors” in the “real world” beyond school. Experiencing a service learning approach within an academic class becomes a critical and essential process for students. Having this experience, particularly when the service learning process is made explicit, provides a reliable model for students to use as means and methods for taking more independent initiatives with an idea for service. By reflecting on their service experience, students may gain a greater awareness of the community and world they live in, and their role and responsibility in improving the lives of themselves and others.</p>

                </div>



            </section>

        </>
    )
}

export default Action